<div class="setBackGroundBlack">
    <div class="centerAlign">

        <div class="fontForTitle" style="margin-top: 3vh; line-height: 30px;">
            About Us
        </div>


        <div class="padding"></div>


        <div class="fontForSubSubText">
            Regal Stones was founded to deliver the best quality standards and ensure lasting experiences for all its
            stakeholders.
        </div>

    </div>
</div>

<app-about-us-second>
    
</app-about-us-second>

<app-about-us-third>

</app-about-us-third>

<app-about-us-forth>
    
</app-about-us-forth>

<app-last-page>
    
</app-last-page>